import { curry } from 'lib/util'
import settings from '@tenant/settings'

/**
 * Get Assembly Icon Event Handler
 *
 * Gets the correct icon for the current assembly from the tenant settings.
 *
 * @param {Gaia.AppModule.Spec} module    the current module composition object
 * @param {Gaia.Component.Spec} component the current action's main component
 * @param {Gaia.PlatformEvent} event      the event object that triggered this handler
 * @returns {*}
 */
const getAssemblyIcon = (module, component, event) => {
  const { productType = null } = event?.detail || event || {}

  const targetProduct = productType
    ? (settings?.documentationTreeNodeIcons || []).find(i => i.nodeType === 'product' && i.name === productType)
    : null

  return targetProduct?.icon
}

export default curry(getAssemblyIcon)
